"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.async-iterator.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-string-tag.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.reverse.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.json.to-string-tag.js");
require("core-js/modules/es.math.to-string-tag.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Suggestion = exports.Input = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _useDebounce = require("use-debounce");
var _ErrorPrompt = require("../../complex/ErrorPrompt");
var _helpers = require("../../core/Input/helpers");
var _index = require("../index");
var _Label = _interopRequireDefault(require("../Label"));
var _InputBase = _interopRequireDefault(require("./InputBase"));
var _excluded = ["fontSize", "label", "subtitle", "errorMessage", "invalid", "decimalPlaces", "delay", "value", "onChange", "type", "unboundedWidth", "orientation", "min", "max", "customEmailValidityCheck", "labelStyles", "disabled", "helperText", "maxLength", "required", "placeholder", "analyticsName", "defaultValue"],
  _excluded2 = ["suggestion", "useSuggestion"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_ndg0d3lom() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/Input.tsx";
  var hash = "715c654cbc845c6b68ddc4421ff01d6cbbb19ac8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/Input.tsx",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 30
        },
        end: {
          line: 21,
          column: 59
        }
      },
      "1": {
        start: {
          line: 132,
          column: 43
        },
        end: {
          line: 405,
          column: 1
        }
      },
      "2": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 159,
          column: 80
        }
      },
      "3": {
        start: {
          line: 160,
          column: 35
        },
        end: {
          line: 162,
          column: 3
        }
      },
      "4": {
        start: {
          line: 166,
          column: 2
        },
        end: {
          line: 176,
          column: 21
        }
      },
      "5": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 169,
          column: 5
        }
      },
      "6": {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 168,
          column: 13
        }
      },
      "7": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 174,
          column: 5
        }
      },
      "8": {
        start: {
          line: 172,
          column: 36
        },
        end: {
          line: 172,
          column: 82
        }
      },
      "9": {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 173,
          column: 43
        }
      },
      "10": {
        start: {
          line: 178,
          column: 46
        },
        end: {
          line: 178,
          column: 70
        }
      },
      "11": {
        start: {
          line: 179,
          column: 33
        },
        end: {
          line: 179,
          column: 64
        }
      },
      "12": {
        start: {
          line: 180,
          column: 38
        },
        end: {
          line: 180,
          column: 62
        }
      },
      "13": {
        start: {
          line: 181,
          column: 32
        },
        end: {
          line: 181,
          column: 68
        }
      },
      "14": {
        start: {
          line: 182,
          column: 44
        },
        end: {
          line: 182,
          column: 74
        }
      },
      "15": {
        start: {
          line: 183,
          column: 30
        },
        end: {
          line: 194,
          column: 3
        }
      },
      "16": {
        start: {
          line: 185,
          column: 6
        },
        end: {
          line: 191,
          column: 7
        }
      },
      "17": {
        start: {
          line: 186,
          column: 33
        },
        end: {
          line: 186,
          column: 57
        }
      },
      "18": {
        start: {
          line: 187,
          column: 38
        },
        end: {
          line: 187,
          column: 62
        }
      },
      "19": {
        start: {
          line: 188,
          column: 8
        },
        end: {
          line: 188,
          column: 27
        }
      },
      "20": {
        start: {
          line: 189,
          column: 8
        },
        end: {
          line: 189,
          column: 34
        }
      },
      "21": {
        start: {
          line: 190,
          column: 8
        },
        end: {
          line: 190,
          column: 45
        }
      },
      "22": {
        start: {
          line: 195,
          column: 19
        },
        end: {
          line: 195,
          column: 51
        }
      },
      "23": {
        start: {
          line: 196,
          column: 21
        },
        end: {
          line: 196,
          column: 93
        }
      },
      "24": {
        start: {
          line: 198,
          column: 23
        },
        end: {
          line: 198,
          column: 94
        }
      },
      "25": {
        start: {
          line: 199,
          column: 34
        },
        end: {
          line: 199,
          column: 62
        }
      },
      "26": {
        start: {
          line: 201,
          column: 24
        },
        end: {
          line: 205,
          column: 3
        }
      },
      "27": {
        start: {
          line: 202,
          column: 4
        },
        end: {
          line: 202,
          column: 30
        }
      },
      "28": {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 203,
          column: 45
        }
      },
      "29": {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 204,
          column: 29
        }
      },
      "30": {
        start: {
          line: 207,
          column: 24
        },
        end: {
          line: 233,
          column: 3
        }
      },
      "31": {
        start: {
          line: 210,
          column: 16
        },
        end: {
          line: 210,
          column: 20
        }
      },
      "32": {
        start: {
          line: 211,
          column: 21
        },
        end: {
          line: 211,
          column: 23
        }
      },
      "33": {
        start: {
          line: 213,
          column: 4
        },
        end: {
          line: 231,
          column: 5
        }
      },
      "34": {
        start: {
          line: 214,
          column: 6
        },
        end: {
          line: 214,
          column: 24
        }
      },
      "35": {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 230,
          column: 7
        }
      },
      "36": {
        start: {
          line: 219,
          column: 38
        },
        end: {
          line: 219,
          column: 64
        }
      },
      "37": {
        start: {
          line: 220,
          column: 10
        },
        end: {
          line: 220,
          column: 44
        }
      },
      "38": {
        start: {
          line: 221,
          column: 10
        },
        end: {
          line: 221,
          column: 54
        }
      },
      "39": {
        start: {
          line: 222,
          column: 10
        },
        end: {
          line: 222,
          column: 16
        }
      },
      "40": {
        start: {
          line: 224,
          column: 10
        },
        end: {
          line: 224,
          column: 45
        }
      },
      "41": {
        start: {
          line: 225,
          column: 10
        },
        end: {
          line: 225,
          column: 16
        }
      },
      "42": {
        start: {
          line: 227,
          column: 10
        },
        end: {
          line: 227,
          column: 58
        }
      },
      "43": {
        start: {
          line: 228,
          column: 10
        },
        end: {
          line: 228,
          column: 16
        }
      },
      "44": {
        start: {
          line: 232,
          column: 4
        },
        end: {
          line: 232,
          column: 33
        }
      },
      "45": {
        start: {
          line: 236,
          column: 23
        },
        end: {
          line: 249,
          column: 3
        }
      },
      "46": {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 248,
          column: 5
        }
      },
      "47": {
        start: {
          line: 239,
          column: 8
        },
        end: {
          line: 239,
          column: 23
        }
      },
      "48": {
        start: {
          line: 241,
          column: 8
        },
        end: {
          line: 241,
          column: 21
        }
      },
      "49": {
        start: {
          line: 245,
          column: 8
        },
        end: {
          line: 245,
          column: 57
        }
      },
      "50": {
        start: {
          line: 247,
          column: 8
        },
        end: {
          line: 247,
          column: 22
        }
      },
      "51": {
        start: {
          line: 251,
          column: 18
        },
        end: {
          line: 274,
          column: 3
        }
      },
      "52": {
        start: {
          line: 252,
          column: 4
        },
        end: {
          line: 273,
          column: 5
        }
      },
      "53": {
        start: {
          line: 254,
          column: 8
        },
        end: {
          line: 254,
          column: 26
        }
      },
      "54": {
        start: {
          line: 256,
          column: 8
        },
        end: {
          line: 256,
          column: 23
        }
      },
      "55": {
        start: {
          line: 258,
          column: 8
        },
        end: {
          line: 258,
          column: 21
        }
      },
      "56": {
        start: {
          line: 262,
          column: 8
        },
        end: {
          line: 262,
          column: 22
        }
      },
      "57": {
        start: {
          line: 266,
          column: 8
        },
        end: {
          line: 266,
          column: 22
        }
      },
      "58": {
        start: {
          line: 270,
          column: 8
        },
        end: {
          line: 270,
          column: 22
        }
      },
      "59": {
        start: {
          line: 272,
          column: 8
        },
        end: {
          line: 272,
          column: 22
        }
      },
      "60": {
        start: {
          line: 276,
          column: 25
        },
        end: {
          line: 289,
          column: 3
        }
      },
      "61": {
        start: {
          line: 277,
          column: 4
        },
        end: {
          line: 288,
          column: 5
        }
      },
      "62": {
        start: {
          line: 279,
          column: 8
        },
        end: {
          line: 279,
          column: 33
        }
      },
      "63": {
        start: {
          line: 281,
          column: 8
        },
        end: {
          line: 281,
          column: 32
        }
      },
      "64": {
        start: {
          line: 283,
          column: 8
        },
        end: {
          line: 283,
          column: 23
        }
      },
      "65": {
        start: {
          line: 285,
          column: 8
        },
        end: {
          line: 285,
          column: 23
        }
      },
      "66": {
        start: {
          line: 287,
          column: 8
        },
        end: {
          line: 287,
          column: 18
        }
      },
      "67": {
        start: {
          line: 291,
          column: 35
        },
        end: {
          line: 300,
          column: 3
        }
      },
      "68": {
        start: {
          line: 292,
          column: 4
        },
        end: {
          line: 299,
          column: 5
        }
      },
      "69": {
        start: {
          line: 294,
          column: 8
        },
        end: {
          line: 294,
          column: 23
        }
      },
      "70": {
        start: {
          line: 296,
          column: 8
        },
        end: {
          line: 296,
          column: 21
        }
      },
      "71": {
        start: {
          line: 298,
          column: 8
        },
        end: {
          line: 298,
          column: 25
        }
      },
      "72": {
        start: {
          line: 306,
          column: 2
        },
        end: {
          line: 310,
          column: 23
        }
      },
      "73": {
        start: {
          line: 307,
          column: 4
        },
        end: {
          line: 309,
          column: 5
        }
      },
      "74": {
        start: {
          line: 308,
          column: 6
        },
        end: {
          line: 308,
          column: 73
        }
      },
      "75": {
        start: {
          line: 312,
          column: 31
        },
        end: {
          line: 318,
          column: 3
        }
      },
      "76": {
        start: {
          line: 313,
          column: 22
        },
        end: {
          line: 313,
          column: 62
        }
      },
      "77": {
        start: {
          line: 314,
          column: 27
        },
        end: {
          line: 314,
          column: 58
        }
      },
      "78": {
        start: {
          line: 315,
          column: 30
        },
        end: {
          line: 315,
          column: 61
        }
      },
      "79": {
        start: {
          line: 316,
          column: 4
        },
        end: {
          line: 316,
          column: 69
        }
      },
      "80": {
        start: {
          line: 317,
          column: 4
        },
        end: {
          line: 317,
          column: 29
        }
      },
      "81": {
        start: {
          line: 320,
          column: 23
        },
        end: {
          line: 333,
          column: 3
        }
      },
      "82": {
        start: {
          line: 321,
          column: 4
        },
        end: {
          line: 321,
          column: 23
        }
      },
      "83": {
        start: {
          line: 322,
          column: 4
        },
        end: {
          line: 322,
          column: 27
        }
      },
      "84": {
        start: {
          line: 323,
          column: 4
        },
        end: {
          line: 323,
          column: 48
        }
      },
      "85": {
        start: {
          line: 324,
          column: 4
        },
        end: {
          line: 324,
          column: 32
        }
      },
      "86": {
        start: {
          line: 325,
          column: 4
        },
        end: {
          line: 332,
          column: 5
        }
      },
      "87": {
        start: {
          line: 328,
          column: 8
        },
        end: {
          line: 328,
          column: 84
        }
      },
      "88": {
        start: {
          line: 329,
          column: 8
        },
        end: {
          line: 329,
          column: 14
        }
      },
      "89": {
        start: {
          line: 331,
          column: 8
        },
        end: {
          line: 331,
          column: 45
        }
      },
      "90": {
        start: {
          line: 335,
          column: 21
        },
        end: {
          line: 338,
          column: 3
        }
      },
      "91": {
        start: {
          line: 336,
          column: 4
        },
        end: {
          line: 336,
          column: 27
        }
      },
      "92": {
        start: {
          line: 337,
          column: 4
        },
        end: {
          line: 337,
          column: 61
        }
      },
      "93": {
        start: {
          line: 341,
          column: 25
        },
        end: {
          line: 341,
          column: 83
        }
      },
      "94": {
        start: {
          line: 343,
          column: 2
        },
        end: {
          line: 404,
          column: 4
        }
      },
      "95": {
        start: {
          line: 407,
          column: 38
        },
        end: {
          line: 409,
          column: 1
        }
      },
      "96": {
        start: {
          line: 408,
          column: 2
        },
        end: {
          line: 408,
          column: 86
        }
      },
      "97": {
        start: {
          line: 411,
          column: 38
        },
        end: {
          line: 411,
          column: 96
        }
      },
      "98": {
        start: {
          line: 411,
          column: 49
        },
        end: {
          line: 411,
          column: 96
        }
      },
      "99": {
        start: {
          line: 418,
          column: 4
        },
        end: {
          line: 431,
          column: 1
        }
      },
      "100": {
        start: {
          line: 420,
          column: 2
        },
        end: {
          line: 430,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 132,
            column: 43
          },
          end: {
            line: 132,
            column: 44
          }
        },
        loc: {
          start: {
            line: 157,
            column: 6
          },
          end: {
            line: 405,
            column: 1
          }
        },
        line: 157
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 166,
            column: 12
          },
          end: {
            line: 166,
            column: 13
          }
        },
        loc: {
          start: {
            line: 166,
            column: 18
          },
          end: {
            line: 176,
            column: 3
          }
        },
        line: 166
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 184,
            column: 5
          }
        },
        loc: {
          start: {
            line: 184,
            column: 69
          },
          end: {
            line: 192,
            column: 5
          }
        },
        line: 184
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 201,
            column: 24
          },
          end: {
            line: 201,
            column: 25
          }
        },
        loc: {
          start: {
            line: 201,
            column: 30
          },
          end: {
            line: 205,
            column: 3
          }
        },
        line: 201
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 207,
            column: 24
          },
          end: {
            line: 207,
            column: 25
          }
        },
        loc: {
          start: {
            line: 209,
            column: 56
          },
          end: {
            line: 233,
            column: 3
          }
        },
        line: 209
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 236,
            column: 23
          },
          end: {
            line: 236,
            column: 24
          }
        },
        loc: {
          start: {
            line: 236,
            column: 29
          },
          end: {
            line: 249,
            column: 3
          }
        },
        line: 236
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 251,
            column: 18
          },
          end: {
            line: 251,
            column: 19
          }
        },
        loc: {
          start: {
            line: 251,
            column: 24
          },
          end: {
            line: 274,
            column: 3
          }
        },
        line: 251
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 276,
            column: 25
          },
          end: {
            line: 276,
            column: 26
          }
        },
        loc: {
          start: {
            line: 276,
            column: 31
          },
          end: {
            line: 289,
            column: 3
          }
        },
        line: 276
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 291,
            column: 35
          },
          end: {
            line: 291,
            column: 36
          }
        },
        loc: {
          start: {
            line: 291,
            column: 87
          },
          end: {
            line: 300,
            column: 3
          }
        },
        line: 291
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 306,
            column: 12
          },
          end: {
            line: 306,
            column: 13
          }
        },
        loc: {
          start: {
            line: 306,
            column: 18
          },
          end: {
            line: 310,
            column: 3
          }
        },
        line: 306
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 312,
            column: 31
          },
          end: {
            line: 312,
            column: 32
          }
        },
        loc: {
          start: {
            line: 312,
            column: 74
          },
          end: {
            line: 318,
            column: 3
          }
        },
        line: 312
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 320,
            column: 23
          },
          end: {
            line: 320,
            column: 24
          }
        },
        loc: {
          start: {
            line: 320,
            column: 67
          },
          end: {
            line: 333,
            column: 3
          }
        },
        line: 320
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 335,
            column: 21
          },
          end: {
            line: 335,
            column: 22
          }
        },
        loc: {
          start: {
            line: 335,
            column: 27
          },
          end: {
            line: 338,
            column: 3
          }
        },
        line: 335
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 407,
            column: 38
          },
          end: {
            line: 407,
            column: 39
          }
        },
        loc: {
          start: {
            line: 408,
            column: 2
          },
          end: {
            line: 408,
            column: 86
          }
        },
        line: 408
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 411,
            column: 38
          },
          end: {
            line: 411,
            column: 39
          }
        },
        loc: {
          start: {
            line: 411,
            column: 49
          },
          end: {
            line: 411,
            column: 96
          }
        },
        line: 411
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 418,
            column: 4
          },
          end: {
            line: 418,
            column: 5
          }
        },
        loc: {
          start: {
            line: 420,
            column: 2
          },
          end: {
            line: 430,
            column: 9
          }
        },
        line: 420
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 133,
            column: 2
          },
          end: {
            line: 133,
            column: 17
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 133,
            column: 13
          },
          end: {
            line: 133,
            column: 17
          }
        }],
        line: 133
      },
      "1": {
        loc: {
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 139,
            column: 13
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 139,
            column: 10
          },
          end: {
            line: 139,
            column: 13
          }
        }],
        line: 139
      },
      "2": {
        loc: {
          start: {
            line: 142,
            column: 2
          },
          end: {
            line: 142,
            column: 15
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 142,
            column: 9
          },
          end: {
            line: 142,
            column: 15
          }
        }],
        line: 142
      },
      "3": {
        loc: {
          start: {
            line: 143,
            column: 2
          },
          end: {
            line: 143,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 143,
            column: 19
          },
          end: {
            line: 143,
            column: 24
          }
        }],
        line: 143
      },
      "4": {
        loc: {
          start: {
            line: 144,
            column: 2
          },
          end: {
            line: 144,
            column: 26
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 144,
            column: 16
          },
          end: {
            line: 144,
            column: 26
          }
        }],
        line: 144
      },
      "5": {
        loc: {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 159,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 159,
            column: 56
          },
          end: {
            line: 159,
            column: 76
          }
        }, {
          start: {
            line: 159,
            column: 79
          },
          end: {
            line: 159,
            column: 80
          }
        }],
        line: 159
      },
      "6": {
        loc: {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 159,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 159,
            column: 24
          }
        }, {
          start: {
            line: 159,
            column: 28
          },
          end: {
            line: 159,
            column: 53
          }
        }],
        line: 159
      },
      "7": {
        loc: {
          start: {
            line: 161,
            column: 4
          },
          end: {
            line: 161,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 161,
            column: 12
          },
          end: {
            line: 161,
            column: 51
          }
        }, {
          start: {
            line: 161,
            column: 54
          },
          end: {
            line: 161,
            column: 56
          }
        }],
        line: 161
      },
      "8": {
        loc: {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 167
      },
      "9": {
        loc: {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 174,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 174,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 171
      },
      "10": {
        loc: {
          start: {
            line: 185,
            column: 6
          },
          end: {
            line: 191,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 6
          },
          end: {
            line: 191,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 185
      },
      "11": {
        loc: {
          start: {
            line: 196,
            column: 21
          },
          end: {
            line: 196,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 196,
            column: 48
          },
          end: {
            line: 196,
            column: 72
          }
        }, {
          start: {
            line: 196,
            column: 75
          },
          end: {
            line: 196,
            column: 93
          }
        }],
        line: 196
      },
      "12": {
        loc: {
          start: {
            line: 198,
            column: 23
          },
          end: {
            line: 198,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 198,
            column: 54
          },
          end: {
            line: 198,
            column: 75
          }
        }, {
          start: {
            line: 198,
            column: 78
          },
          end: {
            line: 198,
            column: 94
          }
        }],
        line: 198
      },
      "13": {
        loc: {
          start: {
            line: 198,
            column: 23
          },
          end: {
            line: 198,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 198,
            column: 23
          },
          end: {
            line: 198,
            column: 31
          }
        }, {
          start: {
            line: 198,
            column: 35
          },
          end: {
            line: 198,
            column: 51
          }
        }],
        line: 198
      },
      "14": {
        loc: {
          start: {
            line: 213,
            column: 4
          },
          end: {
            line: 231,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 213,
            column: 4
          },
          end: {
            line: 231,
            column: 5
          }
        }, {
          start: {
            line: 215,
            column: 11
          },
          end: {
            line: 231,
            column: 5
          }
        }],
        line: 213
      },
      "15": {
        loc: {
          start: {
            line: 216,
            column: 6
          },
          end: {
            line: 230,
            column: 7
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 217,
            column: 8
          },
          end: {
            line: 222,
            column: 16
          }
        }, {
          start: {
            line: 223,
            column: 8
          },
          end: {
            line: 225,
            column: 16
          }
        }, {
          start: {
            line: 226,
            column: 8
          },
          end: {
            line: 228,
            column: 16
          }
        }, {
          start: {
            line: 229,
            column: 8
          },
          end: {
            line: 229,
            column: 16
          }
        }],
        line: 216
      },
      "16": {
        loc: {
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 248,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 238,
            column: 6
          },
          end: {
            line: 239,
            column: 23
          }
        }, {
          start: {
            line: 240,
            column: 6
          },
          end: {
            line: 241,
            column: 21
          }
        }, {
          start: {
            line: 242,
            column: 6
          },
          end: {
            line: 242,
            column: 21
          }
        }, {
          start: {
            line: 243,
            column: 6
          },
          end: {
            line: 243,
            column: 20
          }
        }, {
          start: {
            line: 244,
            column: 6
          },
          end: {
            line: 245,
            column: 57
          }
        }, {
          start: {
            line: 246,
            column: 6
          },
          end: {
            line: 247,
            column: 22
          }
        }],
        line: 237
      },
      "17": {
        loc: {
          start: {
            line: 245,
            column: 15
          },
          end: {
            line: 245,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 245,
            column: 35
          },
          end: {
            line: 245,
            column: 44
          }
        }, {
          start: {
            line: 245,
            column: 47
          },
          end: {
            line: 245,
            column: 56
          }
        }],
        line: 245
      },
      "18": {
        loc: {
          start: {
            line: 252,
            column: 4
          },
          end: {
            line: 273,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 253,
            column: 6
          },
          end: {
            line: 254,
            column: 26
          }
        }, {
          start: {
            line: 255,
            column: 6
          },
          end: {
            line: 256,
            column: 23
          }
        }, {
          start: {
            line: 257,
            column: 6
          },
          end: {
            line: 258,
            column: 21
          }
        }, {
          start: {
            line: 259,
            column: 6
          },
          end: {
            line: 262,
            column: 22
          }
        }, {
          start: {
            line: 263,
            column: 6
          },
          end: {
            line: 266,
            column: 22
          }
        }, {
          start: {
            line: 267,
            column: 6
          },
          end: {
            line: 270,
            column: 22
          }
        }, {
          start: {
            line: 271,
            column: 6
          },
          end: {
            line: 272,
            column: 22
          }
        }],
        line: 252
      },
      "19": {
        loc: {
          start: {
            line: 277,
            column: 4
          },
          end: {
            line: 288,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 278,
            column: 6
          },
          end: {
            line: 279,
            column: 33
          }
        }, {
          start: {
            line: 280,
            column: 6
          },
          end: {
            line: 281,
            column: 32
          }
        }, {
          start: {
            line: 282,
            column: 6
          },
          end: {
            line: 283,
            column: 23
          }
        }, {
          start: {
            line: 284,
            column: 6
          },
          end: {
            line: 285,
            column: 23
          }
        }, {
          start: {
            line: 286,
            column: 6
          },
          end: {
            line: 287,
            column: 18
          }
        }],
        line: 277
      },
      "20": {
        loc: {
          start: {
            line: 292,
            column: 4
          },
          end: {
            line: 299,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 293,
            column: 6
          },
          end: {
            line: 294,
            column: 23
          }
        }, {
          start: {
            line: 295,
            column: 6
          },
          end: {
            line: 296,
            column: 21
          }
        }, {
          start: {
            line: 297,
            column: 6
          },
          end: {
            line: 298,
            column: 25
          }
        }],
        line: 292
      },
      "21": {
        loc: {
          start: {
            line: 307,
            column: 4
          },
          end: {
            line: 309,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 307,
            column: 4
          },
          end: {
            line: 309,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 307
      },
      "22": {
        loc: {
          start: {
            line: 307,
            column: 8
          },
          end: {
            line: 307,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 307,
            column: 8
          },
          end: {
            line: 307,
            column: 24
          }
        }, {
          start: {
            line: 307,
            column: 28
          },
          end: {
            line: 307,
            column: 56
          }
        }],
        line: 307
      },
      "23": {
        loc: {
          start: {
            line: 316,
            column: 22
          },
          end: {
            line: 316,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 316,
            column: 46
          },
          end: {
            line: 316,
            column: 63
          }
        }, {
          start: {
            line: 316,
            column: 66
          },
          end: {
            line: 316,
            column: 67
          }
        }],
        line: 316
      },
      "24": {
        loc: {
          start: {
            line: 325,
            column: 4
          },
          end: {
            line: 332,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 326,
            column: 6
          },
          end: {
            line: 326,
            column: 20
          }
        }, {
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 329,
            column: 14
          }
        }, {
          start: {
            line: 330,
            column: 6
          },
          end: {
            line: 331,
            column: 45
          }
        }],
        line: 325
      },
      "25": {
        loc: {
          start: {
            line: 341,
            column: 25
          },
          end: {
            line: 341,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 341,
            column: 26
          },
          end: {
            line: 341,
            column: 34
          }
        }, {
          start: {
            line: 341,
            column: 38
          },
          end: {
            line: 341,
            column: 54
          }
        }, {
          start: {
            line: 341,
            column: 58
          },
          end: {
            line: 341,
            column: 71
          }
        }, {
          start: {
            line: 341,
            column: 76
          },
          end: {
            line: 341,
            column: 83
          }
        }],
        line: 341
      },
      "26": {
        loc: {
          start: {
            line: 346,
            column: 21
          },
          end: {
            line: 346,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 346,
            column: 47
          },
          end: {
            line: 346,
            column: 52
          }
        }, {
          start: {
            line: 346,
            column: 55
          },
          end: {
            line: 346,
            column: 63
          }
        }],
        line: 346
      },
      "27": {
        loc: {
          start: {
            line: 347,
            column: 18
          },
          end: {
            line: 347,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 347,
            column: 44
          },
          end: {
            line: 347,
            column: 52
          }
        }, {
          start: {
            line: 347,
            column: 55
          },
          end: {
            line: 347,
            column: 57
          }
        }],
        line: 347
      },
      "28": {
        loc: {
          start: {
            line: 348,
            column: 28
          },
          end: {
            line: 348,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 348,
            column: 45
          },
          end: {
            line: 348,
            column: 51
          }
        }, {
          start: {
            line: 348,
            column: 54
          },
          end: {
            line: 348,
            column: 61
          }
        }],
        line: 348
      },
      "29": {
        loc: {
          start: {
            line: 350,
            column: 7
          },
          end: {
            line: 375,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 350,
            column: 8
          },
          end: {
            line: 350,
            column: 13
          }
        }, {
          start: {
            line: 350,
            column: 17
          },
          end: {
            line: 350,
            column: 25
          }
        }, {
          start: {
            line: 351,
            column: 8
          },
          end: {
            line: 374,
            column: 15
          }
        }],
        line: 350
      },
      "30": {
        loc: {
          start: {
            line: 355,
            column: 14
          },
          end: {
            line: 355,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 355,
            column: 40
          },
          end: {
            line: 355,
            column: 46
          }
        }, {
          start: {
            line: 355,
            column: 49
          },
          end: {
            line: 355,
            column: 51
          }
        }],
        line: 355
      },
      "31": {
        loc: {
          start: {
            line: 356,
            column: 14
          },
          end: {
            line: 356,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 356,
            column: 40
          },
          end: {
            line: 356,
            column: 42
          }
        }, {
          start: {
            line: 356,
            column: 45
          },
          end: {
            line: 356,
            column: 51
          }
        }],
        line: 356
      },
      "32": {
        loc: {
          start: {
            line: 358,
            column: 11
          },
          end: {
            line: 368,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 358,
            column: 11
          },
          end: {
            line: 358,
            column: 16
          }
        }, {
          start: {
            line: 359,
            column: 12
          },
          end: {
            line: 367,
            column: 20
          }
        }],
        line: 358
      },
      "33": {
        loc: {
          start: {
            line: 363,
            column: 21
          },
          end: {
            line: 363,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 363,
            column: 32
          },
          end: {
            line: 363,
            column: 44
          }
        }, {
          start: {
            line: 363,
            column: 47
          },
          end: {
            line: 363,
            column: 56
          }
        }],
        line: 363
      },
      "34": {
        loc: {
          start: {
            line: 369,
            column: 11
          },
          end: {
            line: 373,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 369,
            column: 11
          },
          end: {
            line: 369,
            column: 19
          }
        }, {
          start: {
            line: 370,
            column: 12
          },
          end: {
            line: 372,
            column: 19
          }
        }],
        line: 369
      },
      "35": {
        loc: {
          start: {
            line: 371,
            column: 31
          },
          end: {
            line: 371,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 371,
            column: 42
          },
          end: {
            line: 371,
            column: 54
          }
        }, {
          start: {
            line: 371,
            column: 57
          },
          end: {
            line: 371,
            column: 70
          }
        }],
        line: 371
      },
      "36": {
        loc: {
          start: {
            line: 390,
            column: 21
          },
          end: {
            line: 390,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 390,
            column: 38
          },
          end: {
            line: 390,
            column: 40
          }
        }, {
          start: {
            line: 390,
            column: 43
          },
          end: {
            line: 390,
            column: 52
          }
        }],
        line: 390
      },
      "37": {
        loc: {
          start: {
            line: 391,
            column: 23
          },
          end: {
            line: 391,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 391,
            column: 23
          },
          end: {
            line: 391,
            column: 34
          }
        }, {
          start: {
            line: 391,
            column: 38
          },
          end: {
            line: 391,
            column: 54
          }
        }],
        line: 391
      },
      "38": {
        loc: {
          start: {
            line: 397,
            column: 9
          },
          end: {
            line: 397,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 397,
            column: 9
          },
          end: {
            line: 397,
            column: 21
          }
        }, {
          start: {
            line: 397,
            column: 25
          },
          end: {
            line: 397,
            column: 39
          }
        }, {
          start: {
            line: 397,
            column: 43
          },
          end: {
            line: 397,
            column: 81
          }
        }],
        line: 397
      },
      "39": {
        loc: {
          start: {
            line: 398,
            column: 9
          },
          end: {
            line: 398,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 398,
            column: 9
          },
          end: {
            line: 398,
            column: 19
          }
        }, {
          start: {
            line: 398,
            column: 23
          },
          end: {
            line: 398,
            column: 56
          }
        }],
        line: 398
      },
      "40": {
        loc: {
          start: {
            line: 399,
            column: 9
          },
          end: {
            line: 401,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 399,
            column: 9
          },
          end: {
            line: 399,
            column: 19
          }
        }, {
          start: {
            line: 400,
            column: 10
          },
          end: {
            line: 400,
            column: 98
          }
        }],
        line: 399
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0, 0],
      "16": [0, 0, 0, 0, 0, 0],
      "17": [0, 0],
      "18": [0, 0, 0, 0, 0, 0, 0],
      "19": [0, 0, 0, 0, 0],
      "20": [0, 0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0, 0],
      "25": [0, 0, 0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0, 0],
      "39": [0, 0],
      "40": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "715c654cbc845c6b68ddc4421ff01d6cbbb19ac8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ndg0d3lom = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ndg0d3lom();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ASSERT_NOT_NULL_ERROR = (cov_ndg0d3lom().s[0]++, 'This field cannot be empty.');
cov_ndg0d3lom().s[1]++;
var Input = exports.Input = function Input(_ref) {
  var _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? (cov_ndg0d3lom().b[0][0]++, 's1') : _ref$fontSize,
    label = _ref.label,
    subtitle = _ref.subtitle,
    errorMessageProp = _ref.errorMessage,
    isInvalid = _ref.invalid,
    initialDecimalPlaces = _ref.decimalPlaces,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? (cov_ndg0d3lom().b[1][0]++, 100) : _ref$delay,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? (cov_ndg0d3lom().b[2][0]++, 'text') : _ref$type,
    _ref$unboundedWidth = _ref.unboundedWidth,
    unboundedWidth = _ref$unboundedWidth === void 0 ? (cov_ndg0d3lom().b[3][0]++, false) : _ref$unboundedWidth,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? (cov_ndg0d3lom().b[4][0]++, 'vertical') : _ref$orientation,
    min = _ref.min,
    max = _ref.max,
    customEmailValidityCheck = _ref.customEmailValidityCheck,
    labelStyles = _ref.labelStyles,
    disabled = _ref.disabled,
    helperText = _ref.helperText,
    maxLength = _ref.maxLength,
    required = _ref.required,
    placeholder = _ref.placeholder,
    analyticsName = _ref.analyticsName,
    defaultValue = _ref.defaultValue,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_ndg0d3lom().f[0]++;
  var decimalPlaces = (cov_ndg0d3lom().s[2]++, (cov_ndg0d3lom().b[6][0]++, initialDecimalPlaces) && (cov_ndg0d3lom().b[6][1]++, initialDecimalPlaces >= 0) ? (cov_ndg0d3lom().b[5][0]++, initialDecimalPlaces) : (cov_ndg0d3lom().b[5][1]++, 0));
  var _ref2 = (cov_ndg0d3lom().s[3]++, _react["default"].useState(value ? (cov_ndg0d3lom().b[7][0]++, (0, _helpers.formatValue)(value, type, decimalPlaces)) : (cov_ndg0d3lom().b[7][1]++, ''))),
    _ref3 = _slicedToArray(_ref2, 2),
    content = _ref3[0],
    updateContent = _ref3[1];

  // This allows us to update the input defaultValue when the defaultValue prop changes
  // https://react.dev/reference/react-dom/components/input#controlling-an-input-with-a-state-variable
  cov_ndg0d3lom().s[4]++;
  (0, _react.useEffect)(function () {
    cov_ndg0d3lom().f[1]++;
    cov_ndg0d3lom().s[5]++;
    if (!defaultValue) {
      cov_ndg0d3lom().b[8][0]++;
      cov_ndg0d3lom().s[6]++;
      return;
    } else {
      cov_ndg0d3lom().b[8][1]++;
    }
    // Added this for cases where the defaultValue is set to undefined at first but then is updated to a value
    cov_ndg0d3lom().s[7]++;
    if (content !== defaultValue) {
      cov_ndg0d3lom().b[9][0]++;
      var formattedDefaultValue = (cov_ndg0d3lom().s[8]++, (0, _helpers.formatValue)(defaultValue, type, decimalPlaces));
      cov_ndg0d3lom().s[9]++;
      updateContent(formattedDefaultValue);
    } else {
      cov_ndg0d3lom().b[9][1]++;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);
  var _ref4 = (cov_ndg0d3lom().s[10]++, _react["default"].useState()),
    _ref5 = _slicedToArray(_ref4, 2),
    cursorPosition = _ref5[0],
    setCursorPosition = _ref5[1];
  var _ref6 = (cov_ndg0d3lom().s[11]++, _react["default"].useState(content)),
    _ref7 = _slicedToArray(_ref6, 2),
    setPreviousContent = _ref7[1];
  var _ref8 = (cov_ndg0d3lom().s[12]++, _react["default"].useState()),
    _ref9 = _slicedToArray(_ref8, 2),
    suggestion = _ref9[0],
    setSuggestion = _ref9[1];
  var _ref10 = (cov_ndg0d3lom().s[13]++, _react["default"].useState(!!isInvalid)),
    _ref11 = _slicedToArray(_ref10, 2),
    invalid = _ref11[0],
    setInvalid = _ref11[1];
  var _ref12 = (cov_ndg0d3lom().s[14]++, _react["default"].useState(false)),
    _ref13 = _slicedToArray(_ref12, 2),
    hasInteracted = _ref13[0],
    setHasInteracted = _ref13[1];
  var _ref14 = (cov_ndg0d3lom().s[15]++, (0, _useDebounce.useDebouncedCallback)( /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, val) {
        var unformattedValue, _ref17, valid, _suggestion;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cov_ndg0d3lom().f[2]++;
              cov_ndg0d3lom().s[16]++;
              if (!onChange) {
                _context.next = 19;
                break;
              }
              cov_ndg0d3lom().b[10][0]++;
              unformattedValue = (cov_ndg0d3lom().s[17]++, (0, _helpers.unformatValue)(val, type));
              cov_ndg0d3lom().s[18]++;
              _context.next = 8;
              return checkValidity(val);
            case 8:
              _ref17 = _context.sent;
              valid = _ref17.valid;
              _suggestion = _ref17.suggestion;
              cov_ndg0d3lom().s[19]++;
              setInvalid(!valid);
              cov_ndg0d3lom().s[20]++;
              setSuggestion(_suggestion);
              cov_ndg0d3lom().s[21]++;
              onChange(e, unformattedValue, valid);
              _context.next = 20;
              break;
            case 19:
              cov_ndg0d3lom().b[10][1]++;
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref16.apply(this, arguments);
      };
    }(), delay)),
    _ref15 = _slicedToArray(_ref14, 1),
    debouncedOnChange = _ref15[0];
  var inputRef = (cov_ndg0d3lom().s[22]++, _react["default"].useRef());
  var checkEmail = (cov_ndg0d3lom().s[23]++, customEmailValidityCheck ? (cov_ndg0d3lom().b[11][0]++, customEmailValidityCheck) : (cov_ndg0d3lom().b[11][1]++, _helpers.checkEmailValidity));
  var errorMessage = (cov_ndg0d3lom().s[24]++, (cov_ndg0d3lom().b[13][0]++, required) && (cov_ndg0d3lom().b[13][1]++, (0, _isEmpty2["default"])(content)) ? (cov_ndg0d3lom().b[12][0]++, ASSERT_NOT_NULL_ERROR) : (cov_ndg0d3lom().b[12][1]++, errorMessageProp));
  var isHorizontalOrientation = (cov_ndg0d3lom().s[25]++, orientation === 'horizontal');
  cov_ndg0d3lom().s[26]++;
  var useSuggestion = function useSuggestion() {
    cov_ndg0d3lom().f[3]++;
    cov_ndg0d3lom().s[27]++;
    updateContent(suggestion);
    cov_ndg0d3lom().s[28]++;
    debouncedOnChange(undefined, suggestion);
    cov_ndg0d3lom().s[29]++;
    setSuggestion(undefined);
  };
  cov_ndg0d3lom().s[30]++;
  var checkValidity = /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(newValue) {
      var valid, suggestion, emailValidityResult;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            cov_ndg0d3lom().f[4]++;
            valid = (cov_ndg0d3lom().s[31]++, true);
            suggestion = (cov_ndg0d3lom().s[32]++, '');
            cov_ndg0d3lom().s[33]++;
            if (newValue) {
              _context2.next = 10;
              break;
            }
            cov_ndg0d3lom().b[14][0]++;
            cov_ndg0d3lom().s[34]++;
            valid = !required;
            _context2.next = 37;
            break;
          case 10:
            cov_ndg0d3lom().b[14][1]++;
            cov_ndg0d3lom().s[35]++;
            _context2.t0 = type;
            _context2.next = _context2.t0 === 'email' ? 15 : _context2.t0 === 'tel' ? 26 : _context2.t0 === 'number' ? 31 : 36;
            break;
          case 15:
            cov_ndg0d3lom().b[15][0]++;
            cov_ndg0d3lom().s[36]++;
            _context2.next = 19;
            return checkEmail(newValue);
          case 19:
            emailValidityResult = _context2.sent;
            cov_ndg0d3lom().s[37]++;
            valid = emailValidityResult.valid;
            cov_ndg0d3lom().s[38]++;
            suggestion = emailValidityResult.suggestion;
            cov_ndg0d3lom().s[39]++;
            return _context2.abrupt("break", 37);
          case 26:
            cov_ndg0d3lom().b[15][1]++;
            cov_ndg0d3lom().s[40]++;
            valid = (0, _helpers.checkTelValidity)(newValue);
            cov_ndg0d3lom().s[41]++;
            return _context2.abrupt("break", 37);
          case 31:
            cov_ndg0d3lom().b[15][2]++;
            cov_ndg0d3lom().s[42]++;
            valid = (0, _helpers.checkNumberValidity)(newValue, min, max);
            cov_ndg0d3lom().s[43]++;
            return _context2.abrupt("break", 37);
          case 36:
            cov_ndg0d3lom().b[15][3]++;
          case 37:
            cov_ndg0d3lom().s[44]++;
            return _context2.abrupt("return", {
              valid: valid,
              suggestion: suggestion
            });
          case 39:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function checkValidity(_x3) {
      return _ref18.apply(this, arguments);
    };
  }();

  // we are using a string to store the input value (even for percent, number, currency) since we have a need to display commas
  cov_ndg0d3lom().s[45]++;
  var getInputMode = function getInputMode() {
    cov_ndg0d3lom().f[5]++;
    cov_ndg0d3lom().s[46]++;
    switch (type) {
      case 'email':
        cov_ndg0d3lom().b[16][0]++;
        cov_ndg0d3lom().s[47]++;
        return 'email';
      case 'tel':
        cov_ndg0d3lom().b[16][1]++;
        cov_ndg0d3lom().s[48]++;
        return 'tel';
      case 'percent':
        cov_ndg0d3lom().b[16][2]++;
      case 'number':
        cov_ndg0d3lom().b[16][3]++;
      case 'currency':
        cov_ndg0d3lom().b[16][4]++;
        cov_ndg0d3lom().s[49]++;
        return decimalPlaces > 0 ? (cov_ndg0d3lom().b[17][0]++, 'decimal') : (cov_ndg0d3lom().b[17][1]++, 'numeric');
      default:
        cov_ndg0d3lom().b[16][5]++;
        cov_ndg0d3lom().s[50]++;
        return 'text';
    }
  };
  cov_ndg0d3lom().s[51]++;
  var getType = function getType() {
    cov_ndg0d3lom().f[6]++;
    cov_ndg0d3lom().s[52]++;
    switch (type) {
      case 'password':
        cov_ndg0d3lom().b[18][0]++;
        cov_ndg0d3lom().s[53]++;
        return 'password';
      case 'email':
        cov_ndg0d3lom().b[18][1]++;
        cov_ndg0d3lom().s[54]++;
        return 'email';
      case 'tel':
        cov_ndg0d3lom().b[18][2]++;
        cov_ndg0d3lom().s[55]++;
        return 'tel';
      case 'percent':
        cov_ndg0d3lom().b[18][3]++;
        cov_ndg0d3lom().s[56]++;
        // NOTE: Number inputs intentionally have the input type of 'text'
        // to allow for formatting with commas
        return 'text';
      case 'number':
        cov_ndg0d3lom().b[18][4]++;
        cov_ndg0d3lom().s[57]++;
        // NOTE: Number inputs intentionally have the input type of 'text'
        // to allow for formatting with commas
        return 'text';
      case 'currency':
        cov_ndg0d3lom().b[18][5]++;
        cov_ndg0d3lom().s[58]++;
        // NOTE: Currency inputs intentionally have the input type of 'text'
        // to allow for formatting with commas and $
        return 'text';
      default:
        cov_ndg0d3lom().b[18][6]++;
        cov_ndg0d3lom().s[59]++;
        return 'text';
    }
  };
  cov_ndg0d3lom().s[60]++;
  var getPlaceholder = function getPlaceholder() {
    cov_ndg0d3lom().f[7]++;
    cov_ndg0d3lom().s[61]++;
    switch (type) {
      case 'email':
        cov_ndg0d3lom().b[19][0]++;
        cov_ndg0d3lom().s[62]++;
        return 'you@example.com';
      case 'tel':
        cov_ndg0d3lom().b[19][1]++;
        cov_ndg0d3lom().s[63]++;
        return '(000) 000-0000';
      case 'currency':
        cov_ndg0d3lom().b[19][2]++;
        cov_ndg0d3lom().s[64]++;
        return '$0.00';
      case 'percent':
        cov_ndg0d3lom().b[19][3]++;
        cov_ndg0d3lom().s[65]++;
        return '0.00%';
      default:
        cov_ndg0d3lom().b[19][4]++;
        cov_ndg0d3lom().s[66]++;
        return '';
    }
  };
  cov_ndg0d3lom().s[67]++;
  var getAutoCompleteAttribute = function getAutoCompleteAttribute() {
    cov_ndg0d3lom().f[8]++;
    cov_ndg0d3lom().s[68]++;
    switch (type) {
      case 'email':
        cov_ndg0d3lom().b[20][0]++;
        cov_ndg0d3lom().s[69]++;
        return 'email';
      case 'tel':
        cov_ndg0d3lom().b[20][1]++;
        cov_ndg0d3lom().s[70]++;
        return 'tel';
      default:
        cov_ndg0d3lom().b[20][2]++;
        cov_ndg0d3lom().s[71]++;
        return undefined;
    }
  };

  /*
    Manually set the cursor position for number/currency inputs. Without this, the cursor
    will always jump to the end of the input string when we add or remove commas.
  */
  cov_ndg0d3lom().s[72]++;
  (0, _react.useEffect)(function () {
    cov_ndg0d3lom().f[9]++;
    cov_ndg0d3lom().s[73]++;
    if ((cov_ndg0d3lom().b[22][0]++, inputRef.current) && (cov_ndg0d3lom().b[22][1]++, cursorPosition !== undefined)) {
      cov_ndg0d3lom().b[21][0]++;
      cov_ndg0d3lom().s[74]++;
      inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
    } else {
      cov_ndg0d3lom().b[21][1]++;
    }
  }, [cursorPosition]);
  cov_ndg0d3lom().s[75]++;
  var updateNumericContent = function updateNumericContent(value, selectionStart) {
    cov_ndg0d3lom().f[10]++;
    var formatted = (cov_ndg0d3lom().s[76]++, (0, _helpers.sanitizeAndFormatNumberWithCommas)(value));
    var changeInLength = (cov_ndg0d3lom().s[77]++, formatted.length - value.length);
    var newCursorPosition = (cov_ndg0d3lom().s[78]++, selectionStart + changeInLength);
    cov_ndg0d3lom().s[79]++;
    setCursorPosition(newCursorPosition > 0 ? (cov_ndg0d3lom().b[23][0]++, newCursorPosition) : (cov_ndg0d3lom().b[23][1]++, 0));
    cov_ndg0d3lom().s[80]++;
    updateContent(formatted);
  };
  cov_ndg0d3lom().s[81]++;
  var handleChange = function handleChange(e) {
    cov_ndg0d3lom().f[11]++;
    cov_ndg0d3lom().s[82]++;
    e.preventDefault();
    cov_ndg0d3lom().s[83]++;
    setHasInteracted(true);
    cov_ndg0d3lom().s[84]++;
    debouncedOnChange(e, e.currentTarget.value);
    cov_ndg0d3lom().s[85]++;
    setPreviousContent(content);
    cov_ndg0d3lom().s[86]++;
    switch (type) {
      case 'number':
        cov_ndg0d3lom().b[24][0]++;
      case 'currency':
        cov_ndg0d3lom().b[24][1]++;
        cov_ndg0d3lom().s[87]++;
        updateNumericContent(e.currentTarget.value, e.currentTarget.selectionStart);
        cov_ndg0d3lom().s[88]++;
        break;
      default:
        cov_ndg0d3lom().b[24][2]++;
        cov_ndg0d3lom().s[89]++;
        updateContent(e.currentTarget.value);
    }
  };
  cov_ndg0d3lom().s[90]++;
  var handleBlur = function handleBlur() {
    cov_ndg0d3lom().f[12]++;
    cov_ndg0d3lom().s[91]++;
    setHasInteracted(true);
    cov_ndg0d3lom().s[92]++;
    updateContent((0, _helpers.formatValue)(content, type, decimalPlaces));
  };

  // An empty required input should only be shown as invalid after the user has interacted with it
  var displayInvalid = (cov_ndg0d3lom().s[93]++, (cov_ndg0d3lom().b[25][0]++, required) && (cov_ndg0d3lom().b[25][1]++, (0, _isEmpty2["default"])(content)) && (cov_ndg0d3lom().b[25][2]++, hasInteracted) || (cov_ndg0d3lom().b[25][3]++, invalid));
  cov_ndg0d3lom().s[94]++;
  return /*#__PURE__*/_react["default"].createElement(_index.Flex, {
    className: "input-container",
    flexDirection: isHorizontalOrientation ? (cov_ndg0d3lom().b[26][0]++, 'row') : (cov_ndg0d3lom().b[26][1]++, 'column'),
    alignItems: isHorizontalOrientation ? (cov_ndg0d3lom().b[27][0]++, 'center') : (cov_ndg0d3lom().b[27][1]++, ''),
    width: ['100%', null, unboundedWidth ? (cov_ndg0d3lom().b[28][0]++, '100%') : (cov_ndg0d3lom().b[28][1]++, '350px')]
  }, ((cov_ndg0d3lom().b[29][0]++, label) || (cov_ndg0d3lom().b[29][1]++, subtitle)) && (cov_ndg0d3lom().b[29][2]++, /*#__PURE__*/_react["default"].createElement(_index.Flex, {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    pr: isHorizontalOrientation ? (cov_ndg0d3lom().b[30][0]++, [3, 4]) : (cov_ndg0d3lom().b[30][1]++, []),
    pb: isHorizontalOrientation ? (cov_ndg0d3lom().b[31][0]++, []) : (cov_ndg0d3lom().b[31][1]++, [2, 3])
  }, (cov_ndg0d3lom().b[32][0]++, label) && (cov_ndg0d3lom().b[32][1]++, /*#__PURE__*/_react["default"].createElement(_Label["default"], _extends({
    htmlFor: props.id,
    fontSize: fontSize,
    required: required,
    color: disabled ? (cov_ndg0d3lom().b[33][0]++, 'neutrals70') : (cov_ndg0d3lom().b[33][1]++, undefined)
  }, labelStyles), label)), (cov_ndg0d3lom().b[34][0]++, subtitle) && (cov_ndg0d3lom().b[34][1]++, /*#__PURE__*/_react["default"].createElement(_index.Flex, {
    pt: 3
  }, /*#__PURE__*/_react["default"].createElement(Subtitle, {
    color: disabled ? (cov_ndg0d3lom().b[35][0]++, 'neutrals70') : (cov_ndg0d3lom().b[35][1]++, 'neutrals100')
  }, subtitle))))), /*#__PURE__*/_react["default"].createElement(_index.Flex, {
    flex: 1,
    flexDirection: "column"
  }, /*#__PURE__*/_react["default"].createElement(_InputBase["default"], _extends({
    analyticsName: analyticsName,
    "aria-disabled": disabled,
    "aria-required": required,
    "aria-invalid": displayInvalid,
    autoComplete: getAutoCompleteAttribute(),
    ref: inputRef,
    required: required,
    fontSize: fontSize,
    onChange: handleChange,
    value: content,
    type: getType(),
    inputMode: getInputMode(),
    maxLength: type === 'tel' ? (cov_ndg0d3lom().b[36][0]++, 16) : (cov_ndg0d3lom().b[36][1]++, maxLength),
    placeholder: (cov_ndg0d3lom().b[37][0]++, placeholder) || (cov_ndg0d3lom().b[37][1]++, getPlaceholder()),
    onBlur: handleBlur,
    disabled: disabled
  }, props)), (cov_ndg0d3lom().b[38][0]++, errorMessage) && (cov_ndg0d3lom().b[38][1]++, displayInvalid) && (cov_ndg0d3lom().b[38][2]++, /*#__PURE__*/_react["default"].createElement(_ErrorPrompt.ErrorPrompt, {
    message: errorMessage
  })), (cov_ndg0d3lom().b[39][0]++, helperText) && (cov_ndg0d3lom().b[39][1]++, /*#__PURE__*/_react["default"].createElement(HelpText, null, helperText)), (cov_ndg0d3lom().b[40][0]++, suggestion) && (cov_ndg0d3lom().b[40][1]++, /*#__PURE__*/_react["default"].createElement(Suggestion, {
    suggestion: suggestion,
    useSuggestion: useSuggestion,
    fontSize: fontSize
  }))));
};
cov_ndg0d3lom().s[95]++;
var Subtitle = function Subtitle(props) {
  cov_ndg0d3lom().f[13]++;
  cov_ndg0d3lom().s[96]++;
  return /*#__PURE__*/_react["default"].createElement(_index.Text, _extends({
    fontWeight: "normal",
    size: "100",
    textAlign: "left",
    lineHeight: "100"
  }, props));
};
cov_ndg0d3lom().s[97]++;
var HelpText = function HelpText(props) {
  cov_ndg0d3lom().f[14]++;
  cov_ndg0d3lom().s[98]++;
  return /*#__PURE__*/_react["default"].createElement(_index.Text, _extends({
    fontSize: "s1",
    mt: 3,
    mb: 0
  }, props));
};
cov_ndg0d3lom().s[99]++;
var Suggestion = exports.Suggestion = function Suggestion(_ref19) {
  var suggestion = _ref19.suggestion,
    useSuggestion = _ref19.useSuggestion,
    props = _objectWithoutProperties(_ref19, _excluded2);
  cov_ndg0d3lom().f[15]++;
  cov_ndg0d3lom().s[100]++;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    _react["default"].createElement(_index.Text, _extends({
      id: "input-suggestion",
      mt: 3,
      color: "brand50",
      cursor: "pointer",
      fontFamily: "sans",
      onClick: useSuggestion
    }, props), "Did you mean \"", suggestion, "\"?")
  );
};
var _default = exports["default"] = Input;